import { GetFFProductsParams } from 'commerce/factFinder/types';

export const updateQueryParamsWithoutReload = (
  queryParams: Record<string, string> | string,
) => {
  // Get current URL search parameters
  const currentParams = new URLSearchParams(window.location.search);

  // Create a new URLSearchParams object from queryParams
  const newQueryParams = new URLSearchParams(queryParams);

  // Append new parameters to the current parameters
  newQueryParams.forEach((value, key) => {
    currentParams.set(key, value);
  });

  // Construct the new URL with the combined parameters
  const newUrl = `?${currentParams.toString()}`;

  return window.history.replaceState(
    { ...window.history.state, as: newUrl, url: newUrl },
    '',
    newUrl,
  );
};

const querySerialization = (query: URLSearchParams) => {
  const readyQuery = new URLSearchParams();

  query.forEach((value, key) => {
    if (key === 'fss') {
      readyQuery.append(key, value);
    } else if (value.includes(':')) {
      const [filterName, filterValue] = value.split(':');
      readyQuery.append(filterName, filterValue);
    } else {
      readyQuery.append(key, value);
    }
  });

  return readyQuery;
};

const queryDeserialization = (
  queryParams: Record<string, string | number | undefined>,
) => {
  const urlParams = new URLSearchParams();

  Object.entries(queryParams).forEach(([key, value]) => {
    if (key === 'fss') {
      urlParams.append(key, String(value));
    } else {
      urlParams.append('substringFilter', `${key}:${value}`);
    }
  });

  return urlParams;
};

export const addQueryParamsWithoutReload = (params: GetFFProductsParams) => {
  const urlParams = new URLSearchParams();

  if (params?.page && params.page !== 1) {
    urlParams.append('page', params.page.toString());
  }

  if (params?.query) {
    urlParams.append('fss', params.query);
  }

  if (params?.filters) {
    for (const [filterName, filterValues] of Object.entries(params.filters)) {
      const values = Array.isArray(filterValues)
        ? filterValues
        : [filterValues];
      for (const value of values) {
        urlParams.append(filterName, String(value));
      }
    }
  }

  const newUrl = `?${querySerialization(urlParams)}`;

  return window.history.replaceState(
    { ...window.history.state, as: newUrl, url: newUrl },
    '',
    newUrl,
  );
};

export const getQueryParam = (name: string) => {
  if (typeof document !== 'undefined') {
    const params = new URLSearchParams(document.location.search);
    return params.get(name);
  }
  return null;
};

export const parseQueryParams = (
  queryParams: Record<string, string | number | undefined>,
) => {
  return queryDeserialization(queryParams);
};
